import Swiper from 'swiper'
import { Pagination } from 'swiper/modules';
import lightGallery from 'lightgallery';

Swiper.use([Pagination])

class Carousel {
    constructor(element) {
        this.carouselWrapper = element

        this.slider = this.carouselWrapper.querySelector('.swiper')
        this.sliderWrapper = this.slider.querySelector('.swiper-wrapper')
        this.swiper

        this.smallViewport = window.matchMedia('(max-width: 767px)')

        this.init()
    }

    init() {
        this.carousel(this)
    }

    carousel(root) {
        this.swiper = new Swiper(this.slider, {
            slidesPerView: 'auto',
            initialSlide: 0,
            speed: 1000,
            spaceBetween: 24,
            loop: true,
            centeredSlides: true,
            pagination: {
                el: this.slider.nextElementSibling,
                clickable: true,
            },
            on: {
                init: function (swiper) {
                    root.updateInfo(root, swiper)
                    const lg = lightGallery(root.sliderWrapper, {
                        licenseKey: 'purchase-in-progress',
                        animateThumb: false,
                        zoomFromOrigin: false,
                        allowMediaOverlap: true,
                        toggleThumb: true,
                        download: false,
                    })
                },
                slideChangeTransitionStart: function (swiper) {
                    root.updateInfo(root, swiper)
                }
            }
        })
    }

    updateInfo(root, swiper) {
        const label = root.carouselWrapper.parentElement.querySelector('.carousel-info__label')
        const link = root.carouselWrapper.parentElement.querySelector('.carousel-info__link')
        const infoMessage = root.carouselWrapper.parentElement.querySelector('.info-message')
        const slides = swiper.slides
        const index = swiper.activeIndex
        label.innerHTML = `${slides[index].dataset.loftno} – ${slides[index].dataset.size} m<sup>2</sup>`

        if (swiper.slides[swiper.activeIndex].dataset.available === 'false') {
            infoMessage.classList.remove('is-hidden')
            link.classList.add('is-hidden')
        } else {
            infoMessage.classList.add('is-hidden')
            link.classList.remove('is-hidden')
        }

        if (link)
            link.href = slides[index].dataset.link
    }
}

const carousel = document.querySelectorAll('.carousel__wrapper')

carousel.forEach(carousel => {
    new Carousel(carousel)
})
